import { http } from "../../request.js";
function getUserInfo() {
  let data = {};
  sessionStorage.getItem("userInfo")
    ? (data = JSON.parse(sessionStorage.getItem("userInfo")))
    : (data = {});
  return data;
}

export default {
  //查询奖励机制列表
  getRewardSystemList(data) {
    return http.post("/queryRewardSystemList", data);
  },
  //添加奖励机制
  addRewardSystem(data) {
    return http.post("/addRewardSystem", data);
  },
  // 编辑奖励机制
  updateRewardSystem(data) {
    return http.post("/updateRewardSystem", data);
  },
  //删除奖励机制
  deleteRewardSystem(data) {
    return http.postForm("/deleteRewardSystem", data);
  },
  //根据id回显一条奖励机制信息
  getOneRewardSystem(data) {
    return http.postForm("/queryRewardSystemById", {
      id: data && data.id
    });
  },
  // 获取测量类型下拉
  getExamTypeList(data) {
    return http.getForm("/queryExamType", data);
  },
  // 获取商品列表
  getCommodityList(data) {
    return http.post("/queryCommodityList", data);
  },
  // 根据id获取一条商品信息
  getOneCommodity(data) {
    return http.postForm("/queryCommodityById", data);
  },
  // 添加商品
  addCommodity(data) {
    return http.post("/addCommodity", data);
  },
  // 编辑商品
  updateCommodity(data) {
    return http.post("/updateCommodity", data);
  },
  // 删除商品
  deleteCommodity(data) {
    return http.postForm("/deleteCommodity", data);
  },
  // 获取商品类型下拉
  getCommodityTypeList(data) {
    return http.postForm("/productCategoryDropdown", data);
  },
  // 获取发货管理列表
  getShippingList(data) {
    return http.post("/queryShippingManagementList", data);
  },
  // 获取上传列表
  getUploadList(data) {
    return http.post("/uploadManagement", data);
  },
  // 获取活动统计
  getActivityStatistics(data) {
    return http.postForm("/activityStatistics", data);
  },
  // 获取快递公司下拉
  getExpressCompanyList(data) {
    return http.postForm("/queryCourierCompany", data);
  },
  // 发货
  shipping(data) {
    return http.post("/goodsShipped", data);
  },
  // 获取物流信息
  getLogisticsInfo(data) {
    return http.postForm("/logistics", data);
  },
  // 获取兑换记录
  getExchangeRecordList(data) {
    return http.postForm("/queryRewardOrderRecord", data);
  },
  // 修改通知人数据
  alterNotifier(data) {
    return http.postForm("/alterNotifier", data);
  },
  // 回显通知人数据
  echoNotifier(data) {
    return http.postForm("/echoNotifier", data);
  }
};

